import React, { useState } from 'react'
import ProjectFolderIcon from '../../assets/ProjectFolderIcon'
import { FolderIcon } from '@heroicons/react/24/outline'

type Folder = {
  folders: Folder[]
  name: string
  totalSize: number
  lastModified: string
}

type Project = Folder

type Props = {
  projects: Project[]
  selected: string
  setSelected: (value: string) => void
}

export default function ProjectList({ projects, selected, setSelected }: Props) {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})

  const toggleExpand = (path: string) => {
    setExpanded((prev) => ({
      ...prev,
      [path]: !prev[path],
    }))
  }

  const renderFolder = (folder: Folder, parentPath: string) => {
    const fullPath = `${parentPath}/${folder.name}`

    return (
      <div key={fullPath}>
        <div
          className={`flex items-center space-x-2 py-1 px-1 hover:!bg-sky-50 ${
            selected === fullPath ? 'bg-sky-100 hover:!bg-sky-100 text-blue-500' : ''
          }`}
        >
          {folder.folders.length > 0 && (
            <button onClick={() => toggleExpand(fullPath)} className='text-gray-600 hover:text-black'>
              {expanded[fullPath] ? '▼' : '▶'}
            </button>
          )}
          <div className='flex cursor-pointer' onClick={() => setSelected(fullPath)}>
            <FolderIcon className='w-5 h-5 mr-2' />
            {folder.name}
          </div>
        </div>

        {expanded[fullPath] && folder.folders.length > 0 && (
          <div className='ml-6'>{folder.folders.map((subFolder) => renderFolder(subFolder, fullPath))}</div>
        )}
      </div>
    )
  }

  return (
    <div className='space-y-4'>
      {projects.map((project) => {
        const projectPath = project.name
        return (
          <div key={project.name}>
            <div
              className={`flex items-center space-x-2 py-2 px-1 hover:!bg-sky-50 ${
                selected === projectPath ? 'bg-sky-100 hover:!bg-sky-100 text-blue-500' : ''
              }`}
            >
              {project.folders.length > 0 && (
                <button onClick={() => toggleExpand(projectPath)} className='text-gray-600 hover:text-black'>
                  {expanded[projectPath] ? '▼' : '▶'}
                </button>
              )}
              <div className='flex cursor-pointer' onClick={() => setSelected(projectPath)}>
                <ProjectFolderIcon className='w-5 h-5 mr-2' fill='#636A7E' />
                {project.name}
              </div>
            </div>

            {expanded[projectPath] && project.folders.length > 0 && (
              <div className='ml-6'>{project.folders.map((folder) => renderFolder(folder, projectPath))}</div>
            )}
          </div>
        )
      })}
    </div>
  )
}
